function values(object) {
    if (object == null) {
        return [];
    }
    return Object.values(object);
}

export { values };
